module.exports = __webpack_public_path__ + "img/ics_o_train-booking-black.97f8d2a4.svg";